import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  TourCategoryModel,
  TourCategoryMutationDeleteInput,
  TourCategoryMutationInput,
  TourCategoryMutationUpdateInput,
} from './model';

export function useCreateTourCategory(
  options?: UseMutationOptions<
    ApiResult<TourCategoryModel>,
    ApiError,
    TourCategoryMutationInput
  >,
): UseMutationResult<
  ApiResult<TourCategoryModel>,
  ApiError,
  TourCategoryMutationInput
> {
  return useMutation<
    ApiResult<TourCategoryModel>,
    ApiError,
    TourCategoryMutationInput
  >(async function (body) {
    return MutationFetchFunction({
      url: 'tour-categories',
      method: 'POST',
      body,
    });
  }, options);
}

export function useUpdateTourCategory(
  options?: UseMutationOptions<
    ApiResult<TourCategoryModel>,
    ApiError,
    TourCategoryMutationUpdateInput
  >,
): UseMutationResult<
  ApiResult<TourCategoryModel>,
  ApiError,
  TourCategoryMutationUpdateInput
> {
  return useMutation<
    ApiResult<TourCategoryModel>,
    ApiError,
    TourCategoryMutationUpdateInput
  >(async function (body) {
    return MutationFetchFunction({
      url: `tour-categories/${body.id}`,
      method: 'PUT',
      body: body.body,
    });
  }, options);
}

export function useDeleteTourCategory(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    TourCategoryMutationDeleteInput
  >,
): UseMutationResult<
  ApiResult<any>,
  ApiError,
  TourCategoryMutationDeleteInput
> {
  return useMutation<ApiResult<any>, ApiError, TourCategoryMutationDeleteInput>(
    async function (body) {
      return MutationFetchFunction({
        url: `tour-categories/${body.id}`,
        method: 'DELETE',
      });
    },
    options,
  );
}
